export { default } from "./ConsultationsList.jsx";
